// extracted by mini-css-extract-plugin
export var shake = "_16-0";